/* eslint-disable no-unused-vars */
import { createLabelEl } from './create-label-el';

export function getListItemEl(classname, item, num) {
  const listEl = $('<li/>', {
    class: `list-item ${classname}`,
  });
  const labelEl = createLabelEl(item, num);
  return listEl.append(labelEl);
}

export function getListWrapperEl(classname) {
  return $('<ul/>', {
    class: `list-wrapper ${classname}`,
  });
}

// sidebar menu-list 생성 재귀함수
export function createListElements(items, depth) {
  depth = depth || 0;

  let classname;
  switch (depth) {
    case 0:
      classname = 'top';
      break;
    default:
      classname = `sub d${depth}`;
  }

  const listItems = [];
  items.forEach((item, ndx) => {
    const $listItem = getListItemEl(classname, item, ndx + 1);
    const hasChild = _.has(item, 'children');
    const hasURL = _.has(item, 'url');
    // console.log(item.name);
    if (hasChild) {
      if (!hasURL) { // 그룹 아이템
        let grpClassname = 'group has-icon';
        // eslint-disable-next-line default-case
        switch (item.name) {
          case 'intro':
          case 'start':
          case 'props':
          // case 'static':
          // case 'appx':
            grpClassname += ' def expanded';
            break;
        }
        $listItem.addClass(grpClassname);
      }
      // 재귀호출
      createListElements(item.children, depth + 1)
        .appendTo($listItem);
    } else if (hasURL) { // 마크다운 아이템
      $listItem.addClass('md');
    }

    listItems.push($listItem);
  });
  // console.log(listItems.length);

  return getListWrapperEl(classname)
    .append(listItems);
}
